
// src/actions/user.js

import api from './gamba-api'
import AccessToken from '../actions/access-token'
import { emitAlertMessage, clearAlertMessage } from './alert-message'
import actions from '../actions'

export const FETCH_NOTIFICATION_SETTINGS = "FETCH_NOTIFICATION_SETTINGS"
export const FETCH_NOTIFICATION_SETTINGS_REQUESTED = "FETCH_NOTIFICATION_SETTINGS_REQUESTED"
export const FETCH_NOTIFICATION_SETTINGS_COMPLETED = "FETCH_NOTIFICATION_SETTINGS_COMPLETED"
export const FETCH_NOTIFICATION_SETTINGS_FAILED = "FETCH_NOTIFICATION_SETTINGS_FAILED"

export function fetchNotificationSettingsRequested() {
  return {
    type: FETCH_NOTIFICATION_SETTINGS_REQUESTED
  }
}

export function fetchNotificationSettings() {
  return function(dispatch) {
    dispatch(fetchNotificationSettingsRequested())
    return api.get(`/notification_settings`)
        .then((results)=> {
          dispatch(fetchNotificationSettingsCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchNotificationSettingsFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function fetchNotificationSettingsCompleted(results) {
  return {
    type: FETCH_NOTIFICATION_SETTINGS_COMPLETED,
    results,
  }
}

export function fetchNotificationSettingsFailed(error) {
  return {
    type: FETCH_NOTIFICATION_SETTINGS_FAILED,
    error,
  }
}

export const UPDATE_NOTIFICATION_SETTINGS = "UPDATE_NOTIFICATION_SETTINGS"
export const UPDATE_NOTIFICATION_SETTINGS_REQUESTED = "UPDATE_NOTIFICATION_SETTINGS_REQUESTED"
export const UPDATE_NOTIFICATION_SETTINGS_COMPLETED = "UPDATE_NOTIFICATION_SETTINGS_COMPLETED"
export const UPDATE_NOTIFICATION_SETTINGS_FAILED = "UPDATE_NOTIFICATION_SETTINGS_FAILED"

export function updateNotificationSettingsRequested() {
  return {
    type: UPDATE_NOTIFICATION_SETTINGS_REQUESTED
  }
}

export function updateNotificationSettings(target_type, notification_type, notification_media, group_id = undefined) {
  return function(dispatch) {
    dispatch(updateNotificationSettingsRequested())
    return api.put(`/notification_settings`, { target_type, notification_type, notification_media, group_id })
        .then((results)=> {
          dispatch(updateNotificationSettingsCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateNotificationSettingsFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updateNotificationSettingsCompleted(results) {
  return {
    type: UPDATE_NOTIFICATION_SETTINGS_COMPLETED,
    results,
  }
}

export function updateNotificationSettingsFailed(error) {
  return {
    type: UPDATE_NOTIFICATION_SETTINGS_FAILED,
    error,
  }
}

export const UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS = "UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS"
export const UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_REQUESTED = "UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_REQUESTED"
export const UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_COMPLETED = "UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_COMPLETED"
export const UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_FAILED = "UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_FAILED"

export function updateNotificationCollectiveSettingsRequested() {
  return {
    type: UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_REQUESTED
  }
}

export function updateNotificationCollectiveSetting(media_type, notify_all) {
  return function(dispatch) {
    dispatch(updateNotificationCollectiveSettingsRequested())
    return api.put(`/notification_settings/updateAll`, { media_type, notify_all })
        .then((results)=> {
          dispatch(updateNotificationCollectiveSettingsCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateNotificationCollectiveSettingsFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updateNotificationCollectiveSettingsCompleted(results) {
  return {
    type: UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_COMPLETED,
    results,
  }
}

export function updateNotificationCollectiveSettingsFailed(error) {
  return {
    type: UPDATE_NOTIFICATION_COLLECTIVE_SETTINGS_FAILED,
    error,
  }
}

export const UPDATE_SCHEDULE_TYPE = "UPDATE_SCHEDULE_TYPE"
export const UPDATE_SCHEDULE_TYPE_REQUESTED = "UPDATE_SCHEDULE_TYPE_REQUESTED"
export const UPDATE_SCHEDULE_TYPE_COMPLETED = "UPDATE_SCHEDULE_TYPE_COMPLETED"
export const UPDATE_SCHEDULE_TYPE_FAILED = "UPDATE_SCHEDULE_TYPE_FAILED"

export function updateScheduleTypeRequested() {
  return {
    type: UPDATE_SCHEDULE_TYPE_REQUESTED
  }
}

export function updateScheduleType(schedule_type) {
  return function(dispatch) {
    dispatch(updateScheduleTypeRequested())
    return api.put(`/notification_settings/schedule_type`, { schedule_type })
        .then((results)=> {
          dispatch(updateScheduleTypeCompleted(results))
          dispatch(actions.fetchCurrentUser())
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateScheduleTypeFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updateScheduleTypeCompleted(results) {
  return {
    type: UPDATE_SCHEDULE_TYPE_COMPLETED,
    results,
  }
}

export function updateScheduleTypeFailed(error) {
  return {
    type: UPDATE_SCHEDULE_TYPE_FAILED,
    error,
  }
}

export const UPDATE_SCHEDULE_ACTIVE = "UPDATE_SCHEDULE_ACTIVE"
export const UPDATE_SCHEDULE_ACTIVE_REQUESTED = "UPDATE_SCHEDULE_ACTIVE_REQUESTED"
export const UPDATE_SCHEDULE_ACTIVE_COMPLETED = "UPDATE_SCHEDULE_ACTIVE_COMPLETED"
export const UPDATE_SCHEDULE_ACTIVE_FAILED = "UPDATE_SCHEDULE_ACTIVE_FAILED"

export function updateScheduleActiveRequested() {
  return {
    type: UPDATE_SCHEDULE_ACTIVE_REQUESTED
  }
}

export function updateScheduleActive(schedule_active) {
  return function(dispatch) {
    dispatch(updateScheduleActiveRequested())
    return api.put(`/notification_settings/schedule_active`, { schedule_active })
        .then((results)=> {
          dispatch(updateScheduleActiveCompleted(results))
          dispatch(actions.fetchCurrentUser())
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateScheduleActiveFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updateScheduleActiveCompleted(results) {
  return {
    type: UPDATE_SCHEDULE_ACTIVE_COMPLETED,
    results,
  }
}

export function updateScheduleActiveFailed(error) {
  return {
    type: UPDATE_SCHEDULE_ACTIVE_FAILED,
    error,
  }
}

export const UPDATE_DAY_SCHEDULE = "UPDATE_DAY_SCHEDULE"
export const UPDATE_DAY_SCHEDULE_REQUESTED = "UPDATE_DAY_SCHEDULE_REQUESTED"
export const UPDATE_DAY_SCHEDULE_COMPLETED = "UPDATE_DAY_SCHEDULE_COMPLETED"
export const UPDATE_DAY_SCHEDULE_FAILED = "UPDATE_DAY_SCHEDULE_FAILED"

export function updateDayScheduleRequested() {
  return {
    type: UPDATE_DAY_SCHEDULE_REQUESTED
  }
}

export function updateDaySchedule(schedule_type, time_type, time_value) {
  return function(dispatch) {
    dispatch(updateDayScheduleRequested())
    return api.put(`/notification_settings/day_schedule`, { schedule_type, time_type, time_value })
        .then((results)=> {
          dispatch(updateDayScheduleCompleted(results))
          dispatch(actions.fetchCurrentUser())
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateDayScheduleFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updateDayScheduleCompleted(results) {
  return {
    type: UPDATE_DAY_SCHEDULE_COMPLETED,
    results,
  }
}

export function updateDayScheduleFailed(error) {
  return {
    type: UPDATE_DAY_SCHEDULE_FAILED,
    error,
  }
}

export const UPDATE_CUSTOM_SCHEDULE = "UPDATE_CUSTOM_SCHEDULE"
export const UPDATE_CUSTOM_SCHEDULE_REQUESTED = "UPDATE_CUSTOM_SCHEDULE_REQUESTED"
export const UPDATE_CUSTOM_SCHEDULE_COMPLETED = "UPDATE_CUSTOM_SCHEDULE_COMPLETED"
export const UPDATE_CUSTOM_SCHEDULE_FAILED = "UPDATE_CUSTOM_SCHEDULE_FAILED"

export function updateCustomScheduleRequested() {
  return {
    type: UPDATE_CUSTOM_SCHEDULE_REQUESTED
  }
}

export function updateCustomSchedule(day_of_week, time_type, time_value) {
  return function(dispatch) {
    dispatch(updateCustomScheduleRequested())
    return api.put(`/notification_settings/custom_schedule`, { day_of_week, time_type, time_value })
        .then((results)=> {
          dispatch(updateCustomScheduleCompleted(results))
          dispatch(actions.fetchCurrentUser())
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateCustomScheduleFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updateCustomScheduleCompleted(results) {
  return {
    type: UPDATE_CUSTOM_SCHEDULE_COMPLETED,
    results,
  }
}

export function updateCustomScheduleFailed(error) {
  return {
    type: UPDATE_CUSTOM_SCHEDULE_FAILED,
    error,
  }
}

export const FETCH_CURRENT_USER = "FETCH_CURRENT_USER"
export const FETCH_CURRENT_USER_REQUESTED = "FETCH_CURRENT_USER_REQUESTED"
export const FETCH_CURRENT_USER_COMPLETED = "FETCH_CURRENT_USER_COMPLETED"
export const FETCH_CURRENT_USER_FAILED = "FETCH_CURRENT_USER_FAILED"

export function fetchCurrentUserRequested() {
  return {
    type: FETCH_CURRENT_USER_REQUESTED
  }
}

export function fetchCurrentUser() {
  return function(dispatch) {
    dispatch(fetchCurrentUserRequested())
    return api.get(`/user`)
        .then((results)=> {
          dispatch(fetchCurrentUserCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(fetchCurrentUserFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])

        })
  }
}

export function fetchCurrentUserCompleted(results) {
  return {
    type: FETCH_CURRENT_USER_COMPLETED,
    results,
  }
}

export function fetchCurrentUserFailed(error) {
  return {
    type: FETCH_CURRENT_USER_FAILED,
    error,
  }
}

export const UPDATE_USER_PROFILE = "UPDATE_USER_PROFILE"
export const UPDATE_USER_PROFILE_REQUESTED = "UPDATE_USER_PROFILE_REQUESTED"
export const UPDATE_USER_PROFILE_COMPLETED = "UPDATE_USER_PROFILE_COMPLETED"
export const UPDATE_USER_PROFILE_FAILED = "UPDATE_USER_PROFILE_FAILED"

export function updateUserProfileRequested() {
  return {
    type: UPDATE_USER_PROFILE_REQUESTED
  }
}

export function updateUserProfile(name, uploadable_file_id, employment_number, department_id, birthday, is_update_birthday, crop, description) {
  return function(dispatch) {
    dispatch(updateUserProfileRequested())
    return api.put(`/user`, { name, uploadable_file_id, employment_number, department_id, birthday, is_update_birthday, crop, description })
        .then((results)=> {
          dispatch(updateUserProfileCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateUserProfileFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updateUserProfileCompleted(results) {
  return {
    type: UPDATE_USER_PROFILE_COMPLETED,
    results,
  }
}

export function updateUserProfileFailed(error) {
  return {
    type: UPDATE_USER_PROFILE_FAILED,
    error,
  }
}

export const UPDATE_PASSWORD = "UPDATE_PASSWORD"
export const UPDATE_PASSWORD_REQUESTED = "UPDATE_PASSWORD_REQUESTED"
export const UPDATE_PASSWORD_COMPLETED = "UPDATE_PASSWORD_COMPLETED"
export const UPDATE_PASSWORD_FAILED = "UPDATE_PASSWORD_FAILED"

export function updatePasswordRequested() {
  return {
    type: UPDATE_PASSWORD_REQUESTED
  }
}

export function updatePassword(current_password, password, password_confirmation) {
  return function(dispatch) {
    dispatch(updatePasswordRequested())
    return api.put(`/user/password`, { current_password, password, password_confirmation })
        .then((results)=> {
          AccessToken.set(results.access_token, ()=> dispatch(updatePasswordCompleted(results)))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updatePasswordFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updatePasswordCompleted(results) {
  return {
    type: UPDATE_PASSWORD_COMPLETED,
    results,
  }
}

export function updatePasswordFailed(error) {
  return {
    type: UPDATE_PASSWORD_FAILED,
    error,
  }
}

export const UPDATE_EMAIL = "UPDATE_EMAIL"
export const UPDATE_EMAIL_REQUESTED = "UPDATE_EMAIL_REQUESTED"
export const UPDATE_EMAIL_COMPLETED = "UPDATE_EMAIL_COMPLETED"
export const UPDATE_EMAIL_FAILED = "UPDATE_EMAIL_FAILED"

export function updateEmailRequested() {
  return {
    type: UPDATE_EMAIL_REQUESTED
  }
}

export function updateEmail(email) {
  return function(dispatch) {
    dispatch(updateEmailRequested())
    return api.put(`/user/email`, { email })
        .then((results)=> {
          dispatch(updateEmailCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateEmailFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updateEmailCompleted(results) {
  return {
    type: UPDATE_EMAIL_COMPLETED,
    results,
  }
}

export function updateEmailFailed(error) {
  return {
    type: UPDATE_EMAIL_FAILED,
    error,
  }
}

export const REQUEST_CONFIRMATION_MAIL = "REQUEST_CONFIRMATION_MAIL"
export const REQUEST_CONFIRMATION_MAIL_REQUESTED = "REQUEST_CONFIRMATION_MAIL_REQUESTED"
export const REQUEST_CONFIRMATION_MAIL_COMPLETED = "REQUEST_CONFIRMATION_MAIL_COMPLETED"
export const REQUEST_CONFIRMATION_MAIL_FAILED = "REQUEST_CONFIRMATION_MAIL_FAILED"

export function requestConfirmationMailRequested() {
  return {
    type: REQUEST_CONFIRMATION_MAIL_REQUESTED
  }
}

export function requestConfirmationMail() {
  return function(dispatch) {
    dispatch(requestConfirmationMailRequested())
    return api.get(`/user/resend_confirmation`)
        .then((results)=> {
          dispatch(requestConfirmationMailCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(requestConfirmationMailFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function requestConfirmationMailCompleted(results) {
  return {
    type: REQUEST_CONFIRMATION_MAIL_COMPLETED,
    results,
  }
}

export function requestConfirmationMailFailed(error) {
  return {
    type: REQUEST_CONFIRMATION_MAIL_FAILED,
    error,
  }
}

export const SAVE_ANNOUNCE_LAST_SEEN_TIME = "SAVE_ANNOUNCE_LAST_SEEN_TIME"
export const SAVE_ANNOUNCE_LAST_SEEN_TIME_REQUESTED = "SAVE_ANNOUNCE_LAST_SEEN_TIME_REQUESTED"
export const SAVE_ANNOUNCE_LAST_SEEN_TIME_COMPLETED = "SAVE_ANNOUNCE_LAST_SEEN_TIME_COMPLETED"
export const SAVE_ANNOUNCE_LAST_SEEN_TIME_FAILED = "SAVE_ANNOUNCE_LAST_SEEN_TIME_FAILED"

export function saveAnnounceLastSeenTimeRequested() {
  return {
    type: SAVE_ANNOUNCE_LAST_SEEN_TIME_REQUESTED
  }
}

export function saveAnnounceLastSeenTime(announce_last_seen_at) {
  return function(dispatch) {
    dispatch(saveAnnounceLastSeenTimeRequested())
    return api.put(`/announce/announce_last_seen_at`, { announce_last_seen_at })
        .then((results)=> {
          dispatch(saveAnnounceLastSeenTimeCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(saveAnnounceLastSeenTimeFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function saveAnnounceLastSeenTimeCompleted(results) {
  return {
    type: SAVE_ANNOUNCE_LAST_SEEN_TIME_COMPLETED,
    results,
  }
}

export function saveAnnounceLastSeenTimeFailed(error) {
  return {
    type: SAVE_ANNOUNCE_LAST_SEEN_TIME_FAILED,
    error,
  }
}

export const UPDATE_USER_MENU_ITEMS_REQUESTED = "UPDATE_USER_MENU_ITEMS_REQUESTED"
export const UPDATE_USER_MENU_ITEMS_COMPLETED = "UPDATE_USER_MENU_ITEMS_COMPLETED"
export const UPDATE_USER_MENU_ITEMS_FAILED = "UPDATE_USER_MENU_ITEMS_FAILED"

export function updateUserMenuItemsRequested() {
  return {
    type: UPDATE_USER_MENU_ITEMS_REQUESTED
  }
}

export function updateUserMenuItems(menuItems) {
  return function(dispatch) {
    dispatch(updateUserMenuItemsRequested())
    return api.put(`/user/menu_items`, { menu_items: menuItems })
        .then((results)=> {
          dispatch(updateUserMenuItemsCompleted(results))
        })
        .catch((error)=> {
          Promise.all([
            dispatch(updateUserMenuItemsFailed(error)),
            dispatch(emitAlertMessage(error, 'error'))
          ])
        })
  }
}

export function updateUserMenuItemsCompleted(results) {
  return {
    type: UPDATE_USER_MENU_ITEMS_COMPLETED,
    results,
  }
}

export function updateUserMenuItemsFailed(error) {
  return {
    type: UPDATE_USER_MENU_ITEMS_FAILED,
    error,
  }
}



// WEBPACK FOOTER //
// ./src/actions/user.js